class AlpineStore {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
   // グローバルストアに isDesktop を登録
  Alpine.store('isDesktop', window.innerWidth >= 768);

  function updateIsDesktop() {
    Alpine.store('isDesktop', window.innerWidth >= 768);
  }

  // ウィンドウのリサイズ時に isDesktop を更新
  window.addEventListener('resize', updateIsDesktop);

  }
}